function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "b5ff990c-8651-4336-a867-bc9acc0cf2fe",
  "data-name": "Path",
  d: "M27.41,13.52a1.26,1.26,0,0,0-.62.25l-.1.09L17.1,23.45l-3.79-3.78a1.21,1.21,0,0,0-1.8,1.61l.09.1L16.24,26a1.22,1.22,0,0,0,1.62.09L18,26,28.4,15.58a1.21,1.21,0,0,0-.72-2.06h-.27Z"
});

var SvgIconActiveTab = function SvgIconActiveTab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconActiveTab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-active-tab.0f2716a8.svg";
export { ForwardRef as ReactComponent };